
import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NavbarOpen() {
    const {t} = useTranslation();
    let activeStyle = {
        textDecoration: "underline",
      };
    return (
        <>
            <div className="flex justify-end">
               

                <div
                className="md:flex flex-grow items-center justify-center lg:justify-end z-50">
                    <ul className="flex md:flex-row list-none">
                    
                        <li className="nav-item flex-auto">
                        <NavLink 
                            style={({ isActive }) =>
                            isActive ? activeStyle : undefined
                            }
                            className="px-1 flex flex-grow items-center text-xl lowercase font-bold leading-snug hover:font-black" to="/about"> {t("linkabout")}</NavLink>
                        </li>
                        
                        <li className="nav-item flex-auto">
                            <NavLink 
                            style={({ isActive }) =>
                            isActive ? activeStyle : undefined
                            }
                            className="px-1 flex items-center text-xl lowercase font-bold leading-snug hover:font-black" to="/projects">{t("linkprojects")}</NavLink>
                        </li>
                        
                        <li className="nav-item flex-auto">
                            <NavLink 
                            style={({ isActive }) =>
                            isActive ? activeStyle : undefined
                            }
                            className="px-1 flex items-center text-xl lowercase font-bold leading-snug hover:font-black" to="/contact">Contact</NavLink>
                        </li>

                    </ul>
                </div>

            </div>
        </>
    )
}